// @ts-check
import React, { useCallback } from 'react';
import { useTranslation } from '../../localization/useTranslation';
import { format } from '../../utils/string';
import { Modal, ModalVariant, Flex, FlexItem } from '@patternfly/react-core';
import { deleteButtons } from './ModalButtons';

/**
 * @typedef {Object} ConfirmDeleteModalProps
 * @prop {boolean} [isLoading=false]
 * @prop {function} onConfirm
 * @prop {() => void} onCancel
 * @prop {object} [item] If set, the modal will be shown
 * @prop {string} itemName
 * @prop {React.ReactNode} [children]
 */

/**
 * Shows a confirmation dialog for deleting an item
 * @param {ConfirmDeleteModalProps} props
 * @returns {JSX.Element}
 */
const ConfirmDeleteModal = ({ isLoading, onConfirm, item, onCancel, itemName, children }) => {
  const T = useTranslation();

  const _onConfirm = useCallback(() => {
    onConfirm(item);
  }, [onConfirm, item]);
  const isOpen = item != null;
  return (
    // @ts-ignore
    <Modal
      variant={ModalVariant.small}
      title={T.modals.confirmdelete.title}
      titleIconVariant="warning"
      isOpen={isOpen}
      onClose={isLoading ? null : onCancel}
      actions={deleteButtons({ T, onDelete: _onConfirm, deleteEnabled: true, onCancel: onCancel, isLoading })}
    >
      <Flex>
        <FlexItem>
          { format(T.modals.confirmdelete.content, itemName) }
        </FlexItem>
        <FlexItem>
          { children }
        </FlexItem>
      </Flex>
    </Modal>
  );
};

export default React.memo(ConfirmDeleteModal);
